import { GRAPH_GROUP_NODE_CLASS_NAME } from "Common/componentUtils/constants";
import { ZOOM_LEVEL } from "Common/dictionaries/zoomLevel";
import { themeVariables } from "Components/theme";
import { Font } from "yfiles";
import { NODE_GROUP_HEADER_HEIGHT, NODE_GROUP_MIN_SIZE, NODE_MIN_SIZE, NODE_ROUND_RADIUS } from "../../constants";
import nodeType from "../nodeType";
export const fontSizeMap = {
    [nodeType.REGULAR]: {
        low: 32,
        medium: 22,
        high: 15
    },
    [nodeType.GROUP]: {
        low: 32,
        medium: 26,
        high: 15
    }
};
export const paddingMap = {
    [nodeType.REGULAR]: {
        low: "0 8px",
        medium: "0 8px 0 70px",
        high: "0 8px 0 70px"
    },
    [nodeType.GROUP]: {
        low: "1px",
        medium: "1px",
        high: "1px"
    }
};
export const font = new Font(themeVariables["font-family-base"], parseInt(themeVariables["font-size-base"]));
export const groupNodeCountMarkDef = `
  <defs>
    <filter id="group-nodes-count-mark" x="0" width="100%" y="-10%" height="120%">
      <feFlood flood-color="${themeVariables["brand-primary-800"]}"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComponentTransfer><feFuncA type="table" tableValues="0 0 0 1"/></feComponentTransfer>
      <feComponentTransfer><feFuncA type="table" tableValues="0 1 1 1 1 1 1 1"/></feComponentTransfer>
      <feComposite operator="over" in="SourceGraphic"/>
    </filter>
  </defs>`;
export const groupNodeRect = (zoomLevel) => `
  <rect
    class="${GRAPH_GROUP_NODE_CLASS_NAME}"
    fill="#fff"
    stroke="{TemplateBinding styleTag, Converter=colorConverter, Parameter=stroke,0,0.2}"
    stroke-width="{TemplateBinding itemSelected, Converter=groupStrokeWidthConverter, Parameter=${zoomLevel === ZOOM_LEVEL.HIGH ? 2 : zoomLevel === ZOOM_LEVEL.MEDIUM ? 8 : 16}}"
    stroke-opacity="1"
    rx="${NODE_ROUND_RADIUS}"
    ry="${NODE_ROUND_RADIUS}"
    shape="round-rectangle"
    width="{TemplateBinding width, Converter=sizeConverter, Parameter=${NODE_GROUP_MIN_SIZE.width}}"
    height="{TemplateBinding height, Converter=sizeConverter, Parameter=${NODE_GROUP_MIN_SIZE.height}}"
    x="0"
    y="0">
  </rect>
  <rect
    x="0"
    y="0"
    width="{TemplateBinding width, Converter=sizeConverter, Parameter=${NODE_GROUP_MIN_SIZE.width}}"
    height="${zoomLevel === ZOOM_LEVEL.HIGH
    ? NODE_GROUP_HEADER_HEIGHT + 10
    : `{TemplateBinding height, Converter=sizeConverter, Parameter=${NODE_GROUP_MIN_SIZE.height}}`}"
    fill="${themeVariables["gray-350"]}"
    stroke-width="0"
    rx="${NODE_ROUND_RADIUS}"
    ry="${NODE_ROUND_RADIUS}"
    shape="round-rectangle"
    style="${zoomLevel === ZOOM_LEVEL.HIGH ? `clip-path: inset(0px 0px ${NODE_ROUND_RADIUS}px 0)` : ""}"
  >
  </rect>`;
export const groupNodeHeaderText = (zoomLevel) => `
  <text
    x="10"
    y="${zoomLevel === ZOOM_LEVEL.HIGH
    ? fontSizeMap[nodeType.GROUP][zoomLevel] * 1.4
    : NODE_GROUP_MIN_SIZE.height / 3.5}"
    font-family=${font.fontFamily}
    font-size="${fontSizeMap[nodeType.GROUP][zoomLevel]}"
    fill="#fff"
  >
    <tspan
      data-content="{Binding, Converter=sourceTaskNameConverter, Parameter=${zoomLevel}}">
    </tspan>
  </text>
  <text
    x="{TemplateBinding width, Converter=groupNodesCountXConverter, Parameter=${zoomLevel}}"
    y="{TemplateBinding height, Converter=groupNodesCountYConverter, Parameter=${zoomLevel}}"
    transform="{Binding, Converter=groupNodesCountTransformConverter, Parameter=${zoomLevel}}"
    font-family=${font.fontFamily}
    font-size="${fontSizeMap[nodeType.GROUP][zoomLevel] * (zoomLevel === ZOOM_LEVEL.HIGH ? 1 : 1.2)}"
    fill="#112232"
    filter="url(#group-nodes-count-mark)"
    xml:space="preserve"
    data-content="{Binding, Converter=groupNodesCountConverter}"
  ></text>`;
export const regularNodeRect = (hasImage, zoomLevel) => `
  <rect
    x="0"
    y="0"
    width="{Binding NodeWidth, Converter=sizeConverter, Parameter=${NODE_MIN_SIZE.width}}"
    height="{Binding NodeHeight, Converter=sizeConverter, Parameter=${NODE_MIN_SIZE.height}}"
    shape="round-rectangle"
    rx="${NODE_ROUND_RADIUS}"
    ry="${NODE_ROUND_RADIUS}"
    class="{Binding Color, Converter=colorToClassConverter}"
    fill="{TemplateBinding styleTag, Converter=colorConverter, Parameter=fill,0,0.2}"
    stroke="{TemplateBinding styleTag, Converter=colorConverter, Parameter=stroke,0.05,1}"
    stroke-width="${zoomLevel !== ZOOM_LEVEL.HIGH ? 3 : "{Binding Color, Converter=defaultStrokeWidthConverter}"}"
    stroke-opacity="1"
    data-zoom-level="${zoomLevel}">
  </rect>
  <rect
    x="${hasImage ? "68" : "2"}"
    y="2"
    width="${hasImage
    ? `{Binding NodeWidth, Converter=sizeInnerConverter, Parameter=70, ${NODE_MIN_SIZE.width}}`
    : `{Binding NodeWidth, Converter=sizeInnerConverter, Parameter=2, ${NODE_MIN_SIZE.width}}`} "
    height="{Binding NodeHeight, Converter=sizeInnerConverter, Parameter=4, ${NODE_MIN_SIZE.height}}"
    shape="round-rectangle"
    rx="${NODE_ROUND_RADIUS}"
    ry="${NODE_ROUND_RADIUS}"
    fill="#fff"
    stroke-width="0"
    fill-opacity="{Binding Color, Converter=needOpacityConverter, Parameter=0.8}"
  >
  </rect>`;
export const nodeImage = `
  <image
    href="{Binding NodeImage}"
    x="10"
    y="7"
    width="50"
    height="50"
    preserveAspectRatio="xMidYMid slice"
    style="object-fit: cover; clip-path: inset(0% round 25px);"
  />`;
export const nodeAdditionalImage = `
  <circle
    x="0"
    y="0"
    r="{Binding NodeDefaultImage, Converter=imageSizeConverter, Parameter=9}"
    fill="#fff"
    transform="translate(55 49)"
  />
  <image
    href="{Binding NodeDefaultImage}"
    x="0"
    y="0"
    transform="translate(47 41)"
    width="{Binding NodeDefaultImage, Converter=imageSizeConverter, Parameter=16}"
    height="{Binding NodeDefaultImage, Converter=imageSizeConverter, Parameter=16}"
    preserveAspectRatio="xMidYMid slice"
    style="object-fit: cover; clip-path: inset(1px round 8px);"
  />`;
